import type { UnionTypeLibelle } from '../../../techniques/UnionTypeLibelle'

export const ResteChargeContribution = ['Investissement', 'FPE', 'FPE10PourcentCDII'] as const
export type ResteChargeContribution = (typeof ResteChargeContribution)[number]

export const ResteChargeContributionLibelle: UnionTypeLibelle<ResteChargeContribution> = {
  Investissement: 'Investissement',
  FPE: 'FPE',
  FPE10PourcentCDII: 'FPE 10% CDII',
} as const
